module.exports = __webpack_public_path__ + "img/wpg.dc37bbb5.png";